import { Tab, TabList } from '@simplywallst/ui-core';
import { Menu, Button, cn } from '@simplywallst/ui-core/next';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { useIsMobileScreen } from '@/hooks/useMedia';

import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { PERIODS, type Period } from '../../types';

interface Props {
  period: Period;
  setPeriod?: (period: Period) => void;
}

export const PeriodSelect = ({ period, setPeriod }: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });
  return isMobileScreen ? (
    <div className="absolute right-x3 rounded-x1 bg-legacy-noir">
      <Menu
        className="min-w-20"
        label={
          <Button variant="subtle" size="medium" className="text-xs text-soft">
            {period}
            <ChevronDownSmallSolid className="fill-soft" />
          </Button>
        }
      >
        {PERIODS.map((_period) => (
          <Menu.Item
            key={`menu-item-${_period}`}
            isSelected={_period === period}
            onAction={() => setPeriod?.(_period)}
          >
            <CheckSolid
              className={cn('fill-brand-01', _period !== period && 'opacity-0')}
            />
            {_period}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  ) : (
    <div className="absolute right-x3 w-[248px] rounded-x1 bg-legacy-noir">
      <TabList templateColumns="repeat(5, auto)">
        {PERIODS.map((n) => (
          <Tab
            key={`period-tab-${n}`}
            styleType="period"
            selected={period === n}
            onClick={() => setPeriod?.(n)}
            value={n}
          >
            {n}
          </Tab>
        ))}
      </TabList>
    </div>
  );
};
